/*
 * @name: 
 * @Author: zxc
 * @Date: 2021-08-23 09:27:40
 * @LastEditors: zxc
 * @LastEditTime: 2021-10-12 09:58:00
 */
import request from '@/utils/request'
import requestNoTime from '@/utils/requestNoTime'
export function login(data) {
  return request({
    url: '/login/login',
    method: 'post',
    data
  })
}

export function deleteFile(data) { // 删除
  return request({
    url: '/Api/fastdfs/delete',
    method: 'post',
    data
  })
}

export function uploadFile(data) { // 上传
  return requestNoTime({
    url: '/Api/fastdfs/upload',
    method: 'post',
    data
  })
}
// 轮播图
export function slideShow_add(data) {
  return request({
    url: '/slideShow/add',
    method: 'post',
    data
  })
}

export function slideShow_update(data) {
  return request({
    url: '/slideShow/update',
    method: 'put',
    data
  })
}

export function slideShow_delete(id) {
  return request({
    url: '/slideShow/delete',
    method: 'delete',
    params: {
      id
    }
  })
}

export function slideShow_findAll() {
  return request({
    url: '/slideShow/findAll',
    method: 'get'
  })
}

export function slideShow_findAllPage(params) {
  return request({
    url: '/slideShow/findAllPage',
    method: 'get',
    params
  })
}

export function slideShow_sortList(data) {
  return request({
    url: '/slideShow/sortList',
    method: 'put',
    data
  })
}

// 解决方案
export function solution_add(data) {
  return request({
    url: '/solution/add',
    method: 'post',
    data
  })
}

export function solution_update(data) {
  return request({
    url: '/solution/update',
    method: 'put',
    data
  })
}

export function solution_delete(id) {
  return request({
    url: '/solution/delete',
    method: 'delete',
    params: {
      id
    }
  })
}

export function solution_findOne(id) {
  return request({
    url: '/solution/findOne',
    method: 'get',
    params: {
      id
    }
  })
}

export function solution_findAll() {
  return request({
    url: '/solution/findAll',
    method: 'get'
  })
}

export function solution_findAllPage(params) {
  return request({
    url: '/solution/findAllPage',
    method: 'get',
    params
  })
}

export function solution_sortList(data) {
  return request({
    url: '/solution/sortList',
    method: 'put',
    data
  })
}

// 热销产品
export function product_add(data) {
  return request({
    url: '/product/add',
    method: 'post',
    data
  })
}

export function product_update(data) {
  return request({
    url: '/product/update',
    method: 'put',
    data
  })
}

export function product_delete(id) {
  return request({
    url: '/product/delete',
    method: 'delete',
    params: {
      id
    }
  })
}

export function product_findAll() {
  return request({
    url: '/product/findAll',
    method: 'get'
  })
}

export function product_findAllPage(params) {
  return request({
    url: '/product/findAllPage',
    method: 'get',
    params
  })
}

export function product_sortList(data) {
  return request({
    url: '/product/sortList',
    method: 'put',
    data
  })
}

// 客户案例
export function case_add(data) {
  return request({
    url: '/case/add',
    method: 'post',
    data
  })
}

export function case_update(data) {
  return request({
    url: '/case/update',
    method: 'put',
    data
  })
}

export function case_delete(id) {
  return request({
    url: '/case/delete',
    method: 'delete',
    params: {
      id
    }
  })
}

export function case_findOne(id) {
  return request({
    url: '/case/findOne',
    method: 'get',
    params: {
      id
    }
  })
}

export function case_findAll() {
  return request({
    url: '/case/findAll',
    method: 'get'
  })
}

export function case_findAllPage(params) {
  return request({
    url: '/case/findAllPage',
    method: 'get',
    params
  })
}

export function case_sortList(data) {
  return request({
    url: '/case/sortList',
    method: 'put',
    data
  })
}

// 合作客户.
export function partner_add(data) {
  return request({
    url: '/partner/add',
    method: 'post',
    data
  })
}

export function partner_update(data) {
  return request({
    url: '/partner/update',
    method: 'put',
    data
  })
}

export function partner_delete(id) {
  return request({
    url: '/partner/delete',
    method: 'delete',
    params: {
      id
    }
  })
}

export function partner_findAll() {
  return request({
    url: '/partner/findAll',
    method: 'get'
  })
}

export function partner_findAllPage(params) {
  return request({
    url: '/partner/findAllPage',
    method: 'get',
    params
  })
}

export function partner_sortList(data) {
  return request({
    url: '/partner/sortList',
    method: 'put',
    data
  })
}
// 解决方案详情
export function solutionDetail_add(data) {
  return request({
    url: '/solutionDetail/add',
    method: 'post',
    data
  })
}

export function solutionDetail_update(data) {
  return request({
    url: '/solutionDetail/update',
    method: 'put',
    data
  })
}

export function solutionDetail_delete(id) {
  return request({
    url: '/solutionDetail/delete',
    method: 'delete',
    params: {
      id
    }
  })
}

export function solutionDetail_findAllPage(params) {
  return request({
    url: '/solutionDetail/findAllPage',
    method: 'get',
    params
  })
}

// 产品分区
export function productArea_add(data) {
  return request({
    url: '/productArea/add',
    method: 'post',
    data
  })
}

export function productArea_update(data) {
  return request({
    url: '/productArea/update',
    method: 'put',
    data
  })
}

export function productArea_delete(id) {
  return request({
    url: '/productArea/delete',
    method: 'delete',
    params: {
      id
    }
  })
}

export function productArea_findAll() {
  return request({
    url: '/productArea/findAll',
    method: 'get'
  })
}

export function productArea_findAllPage(params) {
  return request({
    url: '/productArea/findAllPage',
    method: 'get',
    params
  })
}

export function productArea_sortList(data) {
  return request({
    url: '/productArea/sortList',
    method: 'put',
    data
  })
}

// 产品列表
export function productList_add(data) {
  return request({
    url: '/productList/add',
    method: 'post',
    data
  })
}

export function productList_update(data) {
  return request({
    url: '/productList/update',
    method: 'put',
    data
  })
}

export function productList_delete(id) {
  return request({
    url: '/productList/delete',
    method: 'delete',
    params: {
      id
    }
  })
}

export function productList_findOne(id) {
  return request({
    url: '/productList/findOne',
    method: 'get',
    params: {
      id
    }
  })
}

export function productList_findAll() {
  return request({
    url: '/productList/findAll',
    method: 'get'
  })
}

export function productList_findAllPage(params) {
  return request({
    url: '/productList/findAllPage',
    method: 'get',
    params
  })
}

export function productList_sortList(data) {
  return request({
    url: '/productList/sortList',
    method: 'put',
    data
  })
}

// 服务与支持
export function service_findAll(params) {
  return request({
    url: '/service/findAll',
    method: 'get',
    params
  })
}

export function service_update(data) {
  return request({
    url: '/service/update',
    method: 'put',
    data
  })
}

// 招聘
export function offer_add(data) {
  return request({
    url: '/offer/add',
    method: 'post',
    data
  })
}

export function offer_update(data) {
  return request({
    url: '/offer/update',
    method: 'put',
    data
  })
}

export function offer_delete(id) {
  return request({
    url: '/offer/delete',
    method: 'delete',
    params: {
      id
    }
  })
}

export function offer_findAll() {
  return request({
    url: '/offer/findAll',
    method: 'get'
  })
}

export function offer_findAllPage(params) {
  return request({
    url: '/offer/findAllPage',
    method: 'get',
    params
  })
}

export function offer_findOne(id) {
  return request({
    url: '/offer/findOne',
    method: 'get',
    params: {
      id
    }
  })
}

export function offer_sortList(data) {
  return request({
    url: '/offer/sortList',
    method: 'put',
    data
  })
}
// 产品详情
export function productDetail_add(data) {
  return request({
    url: '/productDetail/add',
    method: 'post',
    data
  })
}

export function productDetail_update(data) {
  return request({
    url: '/productDetail/update',
    method: 'put',
    data
  })
}

export function productDetail_delete(id) {
  return request({
    url: '/productDetail/delete',
    method: 'delete',
    params: {
      id
    }
  })
}

export function productDetail_findAll() {
  return request({
    url: '/productDetail/findAll',
    method: 'get'
  })
}

export function productDetail_findAllPage(params) {
  return request({
    url: '/productDetail/findAllPage',
    method: 'get',
    params
  })
}

export function productDetail_findOne(id) {
  return request({
    url: '/productDetail/findOne',
    method: 'get',
    params: {
      id
    }
  })
}

export function productDetail_sortList(data) {
  return request({
    url: '/productDetail/sortList',
    method: 'put',
    data
  })
}

// 丹氏
export function introduction_add(data) {
  return request({
    url: '/introduction/add',
    method: 'post',
    data
  })
}

export function introduction_update(data) {
  return request({
    url: '/introduction/update',
    method: 'put',
    data
  })
}

export function introduction_delete(id) {
  return request({
    url: '/introduction/delete',
    method: 'delete',
    params: {
      id
    }
  })
}

export function introduction_findAll() {
  return request({
    url: '/introduction/findAll',
    method: 'get'
  })
}

export function introduction_findAllPage(params) {
  return request({
    url: '/introduction/findAllPage',
    method: 'get',
    params
  })
}

export function introduction_findOne(id) {
  return request({
    url: '/introduction/findOne',
    method: 'get',
    params: {
      id
    }
  })
}

export function introduction_sortList(data) {
  return request({
    url: '/introduction/sortList',
    method: 'put',
    data
  })
}

// 邮件
export function mailSend_send1 (data) {
  return request({
    url: '/mailSend/send1',
    method: 'post',
    data
  })
}

export function mailSend_send2 (data) {
  return request({
    url: '/mailSend/send2',
    method: 'post',
    data
  })
}

export function mailSend_send3 (data) {
  return request({
    url: '/mailSend/send3',
    method: 'post',
    data
  })
}

// 活动
export function activity_add(data) {
  return request({
    url: '/activity/add',
    method: 'post',
    data
  })
}

export function activity_update(data) {
  return request({
    url: '/activity/update',
    method: 'put',
    data
  })
}

export function activity_delete(id) {
  return request({
    url: '/activity/delete',
    method: 'delete',
    params: {
      id
    }
  })
}

export function activity_findAll() {
  return request({
    url: '/activity/findAll',
    method: 'get'
  })
}

export function activity_findAllPage(params) {
  return request({
    url: '/activity/findAllPage',
    method: 'get',
    params
  })
}

export function activity_findOne(id) {
  return request({
    url: '/activity/findOne',
    method: 'get',
    params: {
      id
    }
  })
}

export function activity_sortList(data) {
  return request({
    url: '/activity/sortList',
    method: 'put',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js